
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 0a8 8 0 108 8 8.008 8.008 0 00-8-8zm.797 11.74c-.21.214-.497.335-.797.336a1.151 1.151 0 01-.43-.089 1.276 1.276 0 01-.367-.241 1.133 1.133 0 01.356-1.842 1.132 1.132 0 011.569 1.039c.003.3-.117.588-.33.797zM9.127 8a1.128 1.128 0 01-2.255 0V5.057a1.128 1.128 0 112.256 0V8z","fill":"currentColor"}})])
          )
        }
      }
    